import { Injectable } from '@angular/core';
import { Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService {

  constructor(private router: Router, private security: SecurityService) { }



  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.security.isTokenValid()) {
      return this.router.createUrlTree(['/login']);
    }
    const group = this.security.getGroupUser();
    const url = state.url;
    if (group === 'ADMIN_FREEMOVE_FE' || group === 'USER_FREEMOVE_FE') {
      return true;
    } else if (
      (group === 'BACK_OFFICE_AGENT' ||
       group === 'BACK_OFFICE_AGENT_ADMIN' ||
       group === 'FLEET_MANAGER' ||
       group === 'FLEET_MANAGER_ADMIN') &&
      !url.startsWith('/fwp')
    ) {
      return this.router.createUrlTree(['/fwp/home']);
    }
    return true;
  }

}
